const indexItems = [
  { letter: 'A', title: 'AI创意设计大赛', desc: '人工智能与创意设计的前沿赛事', count: 156 },
  { letter: 'B', title: '编剧创作大赛', desc: '原创剧本与故事创作竞技', count: 89 },
  { letter: 'C', title: 'Cosplay大赛', desc: '角色还原与创意造型比拼', count: 203 },
  { letter: 'D', title: '短视频创作大赛', desc: '30秒短视频创意挑战', count: 342 },
  { letter: 'E', title: '电竞比赛', desc: '热门电竞项目的竞技赛事', count: 278 },
  { letter: 'F', title: '服装设计大赛', desc: '原创服装设计与潮流竞技', count: 67 },
  { letter: 'G', title: '歌唱比赛', desc: '各类声乐竞技与选秀赛事', count: 198 },
  { letter: 'H', title: '绘画创作大赛', desc: '插画、水彩、油画全类型覆盖', count: 134 },
  { letter: 'I', title: 'Illustration插画赛', desc: '商业插画与艺术插画评选', count: 112 },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          专题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口完整专题索引，按类别快速浏览每日大赛列表
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.letter}
              className="flex items-start gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:border-primary-200"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <span className="text-sm font-bold text-primary-700 font-heading">{item.letter}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 truncate">
                  {item.desc}
                </p>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                {item.count}篇
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}